import { Navigate, Route, Routes } from "react-router-dom";

import { isAuthenticated } from "../utils/auth";
import { FinancialProvider } from "../context/FinancialContext";

import Returns from "../pages/Financial/Returns/Returns";
import CostCenter from "../pages/Financial/CostCenter/CostCenter";
import AccountReceivable from "../pages/Financial/AccountReceivable/AccountReceivable";
import DownloadParcel from "../pages/Financial/AccountReceivable/DownloadParcel/DowloadParcel";
import ReversalReport from "../pages/Financial/ReversalReport/ReversalReport";
import ViewShipping from "../pages/Financial/ViewShipping/ViewShipping";
import AccountToPay from "../pages/Financial/AccountToPay/AccountToPay";
import DownloadParcelToPay from "../pages/Financial/AccountToPay/DownloadParcel/DowloadParcelToPay";
import { LaunchCommission } from "../pages/Commission/LaunchCommission";
import { LaunchCommissionSale } from "../pages/Commission/LaunchCommissionSale";
import { LaunchCommissionView } from "../pages/Commission/LaunchCommissionView";
import BanksSync from "../pages/Financial/BankSync/BanksSync";

const PrivateRoute = ({ children }) => {
  const auth = isAuthenticated();
  return auth ? children : <Navigate to="/" />;
};

export const FinancialRoute = () => (
  <FinancialProvider>
    <PrivateRoute>
      <Routes>
        <Route path="/accountReceivable" element={<AccountReceivable />} />
        <Route path="/accountToPay" element={<AccountToPay />} />
        <Route path="/costCenter" element={<CostCenter />} />
        <Route path="/returns" element={<Returns />} />
        <Route path="/downloadParcel" element={<DownloadParcel />} />
        <Route path="/downloadParcelToPay" element={<DownloadParcelToPay />} />
        <Route path="/reversalReport" element={<ReversalReport />} />
        <Route path="/viewShipping" element={<ViewShipping />} />
        <Route path="/launchCommission" element={<LaunchCommission />} />
        <Route
          path="/launchCommissionSale"
          element={<LaunchCommissionSale />}
        />
        <Route path="/viewCommission" element={<LaunchCommissionView />} />
        <Route path="/banksSync" element={<BanksSync />} />
      </Routes>
    </PrivateRoute>
  </FinancialProvider>
);
